import { categories } from '@/mocks/categories';
import { homeContent } from '@/mocks/content';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-accent-900 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          <div>
            <a href="/" className="font-heading text-xl md:text-2xl font-bold text-background-50 whitespace-nowrap cursor-pointer">
              YOYBUY<span className="text-accent-300">.my</span>
            </a>
            <p className="text-sm text-background-50/60 leading-relaxed mt-4">
              {homeContent.footerDescription}
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/50 mb-4">
              Навигация
            </h4>
            <div className="flex flex-col gap-3">
              <a href="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">Главная</a>
              <a href="#categories" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">Категории</a>
              <a href="#about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">О системе</a>
              <a href="#blog" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">Блог</a>
              <Link
                to="/article/yoybuy-spreadsheet-guide"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="text-sm text-background-50/70 hover:text-background-50 transition-colors text-left cursor-pointer"
              >
                Руководство YOYBUY
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/50 mb-4">
              Категории
            </h4>
            <div className="flex flex-col gap-3">
              {categories.slice(0, 7).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-wider text-background-50/50 mb-4">
              Ещё категории
            </h4>
            <div className="flex flex-col gap-3">
              {categories.slice(7).map((cat) => (
                <a
                  key={cat.id}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {cat.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} YOYBUY.my — Все права защищены.
            </p>
            <div className="flex items-center gap-6">
              <a href="/" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer">
                Главная
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer"
              >
                Kaspreadsheet.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}